import { FC } from 'react';

interface ChevronDownSmallIconProps {
  width?: string;
  height?: string;
  color?: string;
}

export const ChevronDownSmallIcon: FC<ChevronDownSmallIconProps> = ({
  width = '12',
  height = '12',
  color = '#1D252D',
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 12" fill="none">
      <path
        d="M5.6464 7.6464L3.8535 5.85351C3.53852 5.53852 3.7616 4.99995 4.20706 4.99995H7.79284C8.2383 4.99995 8.46138 5.53853 8.1464 5.85351L6.3535 7.6464C6.15824 7.84166 5.84166 7.84166 5.6464 7.6464Z"
        fill={color}
      />
    </svg>
  );
};
